<template>
    <div class="bg-light p-3 mt-3 sidebar-sub-container" id="duration">
        <h3 class="sidebar-sub-container-headline">Deine Mindestlaufzeit
            <span class="sidebar-edit-vehicle"
                  data-toggle="modal"
                  data-target="#durationModal"
                  id="checkout_sidebar_duration_modal_trigger"
                  dusk="checkout_sidebar_duration_modal_trigger"
            >
                <i class="far fa-pencil-alt"></i>
            </span>
        </h3>
        <p class="sidebar-sub-container-body mb-2">
            {{ duration.title }}<br>
        </p>
        <ul class="li-checkmark">
            <li><i class="fal fa-check text-success"></i> Im Anschluss monatlich kündbar oder weiterfahren</li>
        </ul>

        <!-- Modal -->
        <div class="modal fade" id="durationModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
             aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title sidebar-sub-container-headline" id="exampleModalLabel">Mindestlaufzeit
                            ändern</h3>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <!--LAUFZEIT-->
                        <div class="checkout-options mb-5">
                            <p class="text-left col-9">
                                verlängert sich automatisch um ein weiteren Monat, solange du nicht kündigst
                            </p>

                            <div class="duration-select row">

                                <div class="col-6">
                                    <select name="duration" id="duration-alt" class="custom-select"
                                            v-model="selected"
                                            :disabled="blackFaarenWeek">
                                        <option v-for="(option, index) in durationOptions"
                                                :value="option.id">{{ option.formatted }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <span class="help-block mt-3" v-if="blackFaarenWeek">
                                                    <i class="far fa-info-circle"></i>
                                                    Nur 6 Monate verfügbar
                                                </span>

                            <input type="hidden" name="duration" :value="selected"
                                   v-if="blackFaarenWeek">

                            <p class="text-left text-success font-italic">
                                <strong>Tipp:</strong> Wähle eine längere Laufzeit für <br
                                    class="d-none d-xl-block">dieses Auto, um monatlich zu sparen
                            </p>

                            <h3 class="sidebar-sub-container-headline mt-5"> Dein All-inclusive-Preis beträgt</h3>
                            <h5 class="sidebar-sub-container-headline"><span v-if="ready">{{ price }} € / Monat</span>
                            </h5>
                            <p class="text-left text-success font-weight-bold" v-if="ready">
                                <span v-if="selected == 3">
                                    Du wählst absolute Flexibilität
                                </span>
                                <span v-else>
                                    Du sparst {{ savings }} € pro Monat
                                </span>
                            </p>
                            <div class="row">
                                <button type="button" class="btn-light p-2 m-2" data-dismiss="modal"><strong>Abbrechen
                                    ohne Änderung</strong>
                                </button>
                                <button type="button" @click="updateDuration" class="btn-primary p-2 m-2"><strong>Änderung
                                    übernehmen</strong>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import PNotify from 'pnotify/dist/es/PNotify';
    import PNotifyStyleMaterial from 'pnotify/dist/es/PNotifyStyleMaterial.js';

    PNotify.defaults.styling = 'bootstrap4';
    PNotify.defaults.icons = 'fontawesome5';

    export default {
        name: "Duration",
        props: ['vehicle', 'subscription', 'durationOptions', 'currentDuration', 'currentMileage'],
        data() {
            return {
                selected: 0,
                ready: false,
                blackFaarenWeek: false,
                durations: [],
            }
        },
        methods: {
            updateDuration() {
                axios.patch('/api/checkout/' + this.subscription.id, {
                    identifier: this.subscription.identifier,
                    subscription: {
                        price: this.price.replace(',', '.'),
                        month_id: this.selected
                    }
                }).then(r => {
                    PNotify.success(r.data.message);
                    this.$emit('duration-updated');
                    $('#durationModal').modal('hide');
                }).catch(e => {
                    PNotify.alert("Leider ist ein Fehler aufgetreten. Versuche es später erneut oder wende dich an unseren Support!");
                })
            },
            getVehiclePrices() {
                return this.vehicle.price_calculations;
            },
            getCurrentDurationObject: function () {
                var self = this;
                return this.durationOptions.find(function (option) {
                    return option.id === self.selected;
                });
            },
        },
        computed: {
            price() {
                let prices = this.getVehiclePrices();
                let duration = this.durationOptions.find(option => {
                    return option.id === this.selected;
                });
                return prices.brutto[duration.months][this.currentMileage.tag].toFixed(2).replace('.', ',');
            },
            savings: function () {
                var currentPrice = this.getVehiclePrices().brutto[this.getCurrentDurationObject().months][this.currentMileage.tag];

                var shortestDuration = this.durationOptions[0];
                var heighestPrice = this.getVehiclePrices().brutto[shortestDuration.months][this.currentMileage.tag];

                var savings = heighestPrice - currentPrice;
                return savings.toFixed(0);
            },
            duration(){
                return this.subscription.duration;
            }
        },
        mounted() {

            if(this.vehicle.category.slug === 'black-faaren-week'){
                this.blackFaarenWeek = true;
                var durationOptionsCopy = JSON.parse(JSON.stringify(this.durationOptions));
                this.durations = durationOptionsCopy.filter(option => option.months == 6);
                this.selected = this.durations[0].id;
            } else {
                this.durations = this.durationOptions;
            }

            this.selected = this.duration.id;
            this.ready = true;
        }
    }
</script>

<style scoped lang="scss">
    #checkout_sidebar_duration_modal_trigger {
        cursor: pointer;
    }
</style>
